module.exports = __webpack_public_path__ + "img/type1_uncheck.d8250513.png";